<template>
  <div
    id="app"
    :class="{ 'app-offline-banner': !isOnline }"
  >
    <div
      v-if="!isOnline"
      class="offline-status-banner"
    >
      No internet connection. This terminal is operating in Offline Mode.
    </div>

    <div
      v-if="isRealtimeReconciliationInProgress"
      class="realtime-reconciliation-overlay"
    >
      <div class="realtime-reconciliation-content">
        <h3>Syncing latest orders...</h3>
        <p>Please wait while this terminal catches up.</p>
      </div>
    </div>

    <router-view />
    <!-- <div
      v-if="secondaryTab"
      id="app-notallowed"
      class="kiosk"
    > -->
    <!-- <div class="row h-100 align-content-center">
        <div class="col-12">
          <h3>You can only open one tab Biyo at a time</h3>
          <h4>Having multiple Biyo tabs open at the same time can cause errors in sales</h4>
        </div>
      </div> -->
    <!-- </div> -->

    <SvgSprite />

    <b-modal
      id="sw-update-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      modal-class="success-popup"
    >
      <div class="text-center modal-complete">
        <svg class="icon icon-icon-success-frame">
          <use xlink:href="#icon-icon-success-frame" />
        </svg>

        <h2>
          {{ $t("sw-modal.new-version") }}
        </h2>

        <span>{{ $t("sw-modal.refresh-page") }}</span>

        <div class="d-flex justify-content-center align-items-center">
          <b-button
            variant="primary"
            @click="updateSW"
          >
            Update
          </b-button>
          <b-button
            variant="outline-primary"
            class="ml-2"
            @click="closeUpdateSW"
          >
            close
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="curbside-pickup"
      hide-footer
      hide-header
      modal-class="success-popup relative"
    >
      <svg
        class="icon icon-icon-x x-icon"
        @click="closeCurbsidePickupModal"
      >
        <use xlink:href="#icon-icon-x" />
      </svg>
      <div class="text-center modal-complete">
        <h2>
          Curbside Pickup
        </h2>

        <h5
          v-if="curbsidePickupOrder"
          class="mb-4"
        >
          Order # {{ curbsidePickupOrder.order_id }}
        </h5>

        <div
          v-if="curbsidePickupOrder"
          class="d-flex justify-content-between mb-4"
        >
          <div v-if="curbsidePickupOrder">
            <h6>Car Model & Color</h6> {{ curbsidePickupOrder.car_model }}
          </div>
          <div v-if="curbsidePickupOrder">
            <h6>Parking #</h6> {{ curbsidePickupOrder.parking_number }}
          </div>
        </div>

        <p>The Customer is outside to pickup the Order. Please proceed.</p>
      </div>
    </b-modal>
    <!-- <b-modal
      id="app-is-offline"
      hide-footer
      hide-header
      no-close-on-backdrop
      modal-class="success-popup"
    >
    <div>
      <span
        @click="$bvModal.hide('app-is-offline')"
        class="close-button"
        aria-label="Close"
      >
        &times;
      </span>
    </div>
    <div class="text-center modal-complete">
      <svg class="icon icon-icon-success-frame">
        <use xlink:href="#icon-icon-success-frame" />
      </svg>

      <h2>
        {{ $t("offline-modal.is-offline") }}
      </h2>

      <div class="d-flex justify-content-center align-items-center">
        <b-button
          variant="primary"
          @click="checkConnection"
        >
          {{ $t("offline-modal.try-again") }}
        </b-button>
      </div>
    </div>
  </b-modal> -->
    <b-modal
      id="dulpicate-tab-modal"
      v-model="secondaryTab"
      hide-header
      no-close-on-backdrop
      centered
      modal-class="duplicate-tab-popup"
      @ok="useHere()"
    >
      <div>
        <span>Biyo is open in another window. Click "Use Here" to use Biyo in this window</span>
      </div>
      <template #modal-footer="{ ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="primary"
          @click="ok"
        >
          Use Here
        </b-button>
      </template>
    </b-modal>
    <NewOrderRecevieModal
      :modal="newOrderReceiveModal"
      @confirm-action="confirmAction"
    />
    <VoidReasonModal />
  </div>
</template>

<script>
import "@/assets/sass/style.scss";
import {
  setCurrentTab
} from './helpers/activeTabMonitor';
import SvgSprite from "@/components/SvgSprite";
import { mapGetters } from "vuex"
import pusherMixin from "@/mixins/pusherMixin";
import NewOrderRecevieModal from "./modals/Order/NewOrderRecevieModal.vue";
import VoidReasonModal from "@/components/Order/VoidReasonModal.vue";
import { initializeQzTray } from "@/helpers/qzTrayInit";
import { ORDER_STATUS } from "@/helpers/order/status";
import { getOrderRemainingBalance } from "@/helpers/order/checkoutBalance";
import liveObjectsService from "@/plugins/liveObjects";

window.rsvp = require("rsvp");
window.RSVP = require("rsvp");
window.sha = require("sha.js");

export default {
  name: "App",
  components: {
    SvgSprite,
    NewOrderRecevieModal,
    VoidReasonModal
  },
  mixins:[
    pusherMixin
  ],
  data () {
    return {
      refreshing: false,
      secondaryTab: false,
      channel: null,
      pusher: null,
      inactivityTimer: null,
      newOrderReceiveModal: {
        title: 'New Order Received',
        text: 'Do you want to go to the Online Order Page?',
        cancelActionText: 'Later',
        confirmActionText: 'Yes',
      },
    };
  },
  computed: {
    ...mapGetters({
      baseUrl: "config/baseUrl",
      store: "config/store",
      curbsidePickupOrder: "order/curbsidePickupOrder",
      autoLogout: 'config/autoLogout',
      isRealtimeReconciliationInProgress: 'orders/isRealtimeReconciliationInProgress',
    }),
    isOnline () {
      return this.$store.getters.connection;
    },
    checkoutOrderFromRoute() {
      const name = this.$route.name;
      if (name !== "OrderCheckout" && name !== "OrderCheckoutV2") {
        return null;
      }
      const raw = this.$route.params.id;
      if (raw === undefined || raw === null) {
        return null;
      }
      const orderKey = String(raw).includes("_") ? raw : parseInt(raw, 10);
      return this.$store.getters["orders/getOrderByIdOrLocalId"](orderKey) || null;
    },
    /** Skip idle logout while checkout has an open order that is not fully paid/settled. */
    suppressAutoLogoutForActiveCheckout() {
      const order = this.checkoutOrderFromRoute;
      if (!order) {
        return false;
      }
      if (
        order.status === ORDER_STATUS.COMPLETED ||
        order.status === ORDER_STATUS.CANCELLED ||
        order.status === ORDER_STATUS.REFUNDED
      ) {
        return false;
      }
      return Math.abs(getOrderRemainingBalance(order)) > 0.005;
    },
  },
  watch: {
    isRealtimeReconciliationInProgress(inProgress) {
      if (inProgress && this.$route.name !== "Pin") {
        this.$router.push({ name: "Pin" }).catch(() => {});
      }
    },
    isOnline (online) {
      if (online) {
        this.ensureSubscribed();
        return this.$bvModal.hide("app-is-offline");
      }
      return this.$bvModal.show("app-is-offline");
    },
    autoLogout: {
      handler() {
        this.handleAutoLogoutChange();
      },
      immediate: true
    },
    $route() {
      this.handleAutoLogoutChange();
    },
    suppressAutoLogoutForActiveCheckout() {
      this.handleAutoLogoutChange();
    },
    baseUrl(newBaseUrl) {
      // baseUrl is only known after the auth config loads (e.g. after login on
      // a fresh session), so the initial mount-time subscribe attempt can miss
      // it. Catch it here once it becomes available.
      if (newBaseUrl) {
        this.ensureSubscribed();
      }
    },
  },
  created() {
    // created channel to communicate between two chrome tabs
    this.channel = new BroadcastChannel('my-channel');
    this.channel.onmessage = this.handleChannelMessage;
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true;
      });
    }
    setCurrentTab(() => {
      // post message when second tab is detected
      this.channel.postMessage('second tab')
   });

  },
  async mounted() {
    // Initialize QZ Tray on app startup
    this.initQzTray();

    // pusher initialization
    this.ensureSubscribed();

    // Load notifications from IndexedDB
    await this.$store.dispatch('loadNotifications');

    // Add visibility change listener to reconnect when tab becomes visible
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // Add beforeunload to persist connection state
    window.addEventListener('beforeunload', this.handleBeforeUnload);

  },
  beforeDestroy() {
    this.clearInactivityTimer();
    this.removeActivityListeners();

    if (this.pusher)
    this.pusher.disconnect();

    // Clean up event listeners
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    async initQzTray() {
      try {
        const result = await initializeQzTray();
        if (!result.success) {
          console.warn("QZ Tray initialization failed:", result.error);
          // Don't show error to user - printing will handle connection when needed
        }
      } catch (error) {
        console.error("Error during QZ Tray initialization:", error);
      }
    },
    updateSW() {
      window.location.reload();
    },
    closeUpdateSW () {
      return this.$bvModal.hide("sw-update-modal");
    },
    closeCurbsidePickupModal () {
      return this.$bvModal.hide("curbside-pickup");
    },
    checkConnection () {
      this.$store.dispatch("setConnection", navigator.onLine);
    },
    handleVisibilityChange() {
      // Screen sleep / tab backgrounding can leave the Pusher and Ably
      // connections stale without either SDK's own retry logic noticing.
      // Force a health check + reconnect whenever the terminal wakes up.
      if (document.visibilityState === 'visible') {
        this.ensureSubscribed();
        liveObjectsService.reconnectIfNeeded();
      }
    },
    handleBeforeUnload() {
      // Unlock all orders locked by this terminal when browser/tab closes
      this.unlockOrdersOnClose();
    },
    unlockOrdersOnClose() {
      try {
        const terminal = this.$store.getters["config/terminal"];
        if (!terminal || !terminal.id) {
          return;
        }

        // Find all orders locked by this terminal
        const allOrders = this.$store.getters["orders/getAllOrders"];
        const lockedOrders = allOrders.filter(order =>
          order.locked_by === terminal.id &&
          (order.status === ORDER_STATUS.OPEN || order.status === ORDER_STATUS.HOLD)
        );

        if (lockedOrders.length === 0) {
          return;
        }

        // Unlock orders in the store (saves to IndexedDB)
        lockedOrders.forEach(order => {
          const unlockedOrder = { ...order, locked_by: null };
          this.$store.dispatch("orders/saveOrder", unlockedOrder);
        });

        // Broadcast unlock via Ably if available, otherwise rely on sync
        // Note: saveOrder mutation already broadcasts via Ably if realtime is active
        // But we also want to ensure sync happens for offline scenarios
        if (navigator.onLine) {
          // Trigger sync to ensure server is updated
          // The saveOrder mutations above will have already broadcast via Ably if realtime is active
          this.$store.dispatch("sync").catch(error => {
            console.warn('[BROWSER CLOSE] Sync failed, but orders unlocked locally:', error);
          });
        }
      } catch (error) {
        console.error('[BROWSER CLOSE] Error unlocking orders:', error);
      }
    },
    handleChannelMessage(event) {
      // hault the previous tab
      if (event.data === 'second tab') {
        this.secondaryTab = true
      }
    },
    useHere() {
      this.channel.postMessage('second tab')
      // location.reload();
    },
    confirmAction() {
      this.$bvModal.hide('new-order-received')
      this.$router.push('/online-orders')
    },
    handleAutoLogoutChange() {
        const isPinPage = this.$route.name === 'Pin';
        if (this.autoLogout && !isPinPage && !this.suppressAutoLogoutForActiveCheckout) {
            this.startInactivityTimer();
            this.addActivityListeners();
        } else {
            this.clearInactivityTimer();
            this.removeActivityListeners();
        }
    },
    startInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityTimer = setTimeout(() => {
            this.logout();
        }, 60000);
    },
    clearInactivityTimer() {
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    },
    resetInactivityTimer() {
        if (this.suppressAutoLogoutForActiveCheckout) {
            return;
        }
        if (this.autoLogout && this.$route.name !== 'Pin') {
            this.startInactivityTimer();
        }
    },
    logout() {
        if (this.suppressAutoLogoutForActiveCheckout) {
            return;
        }
        if (this.$route.name !== 'Pin') {
             this.$router.push({ name: 'Pin' });
        }
    },
    addActivityListeners() {
        window.addEventListener('touchstart', this.resetInactivityTimer);
        window.addEventListener('mousedown', this.resetInactivityTimer);
        window.addEventListener('keypress', this.resetInactivityTimer);
    },
    removeActivityListeners() {
        window.removeEventListener('touchstart', this.resetInactivityTimer);
        window.removeEventListener('mousedown', this.resetInactivityTimer);
        window.removeEventListener('keypress', this.resetInactivityTimer);
    },
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #eee;
  height: 100%;
  min-height: 100vh;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 20px;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}

.test-top {
  position: fixed;
  top: 0;
  left: 50%;
  right: 0;
  z-index: 100000;
}

.x-icon {
  position: absolute;
  top: 0;
  right: 10px;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

#app.app-offline-banner {
  margin-top: 28px;
  min-height: calc(100vh - 28px);
  height: calc(100% - 28px);
}

.offline-status-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000001;
  height: 28px;
  line-height: 28px;
  background: #d32f2f;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

#app.app-offline-banner .main-navbar {
  top: 28px !important;
}

#app.app-offline-banner .sidebar,
#app.app-offline-banner .sidebar-mask {
  top: 28px;
  height: calc(100% - 28px) !important;
}

.realtime-reconciliation-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  z-index: 1000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.realtime-reconciliation-content {
  background: #fff;
  border-radius: 12px;
  padding: 20px 28px;
  text-align: center;
  max-width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.realtime-reconciliation-content h3 {
  margin: 0 0 8px;
  font-size: 22px;
}

.realtime-reconciliation-content p {
  margin: 0;
  color: #64748b;
}
</style>
